import { GD } from "src/GD";

export class MerchantAuthService {

	constructor() {
		GD.REQ_MERCHANT_AUTH_CREATE.listener = async (data) => {
			const response = await GD.REQ_API.request({
				method: "merchant/auth/create",
				data: data
			})
			return response;
		}

		GD.REQ_MERCHANT_AUTH_LIST.listener = async (data) => {

			if (!data)
				return { error: { code: -100, message: "ignore" } };

			if (!data.website_id)
				return { error: { code: -101, message: "ignore" } };

			const response = await GD.REQ_API.request({
				method: "merchant/auth/get",
				data: data
			})
			return response;
		}
	}
}